// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/black_hat.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * OUT-08: early estimates, independent of formal Proposal pricing and staffing LOE.
 * No implicit conversion between units. All decimals are plain nonnegative base-10
 * strings (up to 4 fractional digits); no exponent notation or binary floats.
 *
 * @generated from enum mono.datagateway.v1.BlackHatQuantityUnit
 */ export var BlackHatQuantityUnit = /*#__PURE__*/ function(BlackHatQuantityUnit) {
    /**
   * @generated from enum value: BLACK_HAT_QUANTITY_UNIT_UNSPECIFIED = 0;
   */ BlackHatQuantityUnit[BlackHatQuantityUnit["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: BLACK_HAT_QUANTITY_UNIT_HOUR = 1;
   */ BlackHatQuantityUnit[BlackHatQuantityUnit["HOUR"] = 1] = "HOUR";
    /**
   * @generated from enum value: BLACK_HAT_QUANTITY_UNIT_DAY = 2;
   */ BlackHatQuantityUnit[BlackHatQuantityUnit["DAY"] = 2] = "DAY";
    /**
   * @generated from enum value: BLACK_HAT_QUANTITY_UNIT_ITEM = 3;
   */ BlackHatQuantityUnit[BlackHatQuantityUnit["ITEM"] = 3] = "ITEM";
    return BlackHatQuantityUnit;
}({});
// Retrieve enum metadata with: proto3.getEnumType(BlackHatQuantityUnit)
proto3.util.setEnumType(BlackHatQuantityUnit, "mono.datagateway.v1.BlackHatQuantityUnit", [
    {
        no: 0,
        name: "BLACK_HAT_QUANTITY_UNIT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "BLACK_HAT_QUANTITY_UNIT_HOUR"
    },
    {
        no: 2,
        name: "BLACK_HAT_QUANTITY_UNIT_DAY"
    },
    {
        no: 3,
        name: "BLACK_HAT_QUANTITY_UNIT_ITEM"
    }
]);
/**
 * GRW-07 (SAD-1129): the black-hat low/high range is DERIVED from the
 * deterministic scenarios (packages/go-common/blackhat.Range), never typed.
 *
 * @generated from enum mono.datagateway.v1.BlackHatScenarioRole
 */ export var BlackHatScenarioRole = /*#__PURE__*/ function(BlackHatScenarioRole) {
    /**
   * @generated from enum value: BLACK_HAT_SCENARIO_ROLE_UNSPECIFIED = 0;
   */ BlackHatScenarioRole[BlackHatScenarioRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: BLACK_HAT_SCENARIO_ROLE_LOW = 1;
   */ BlackHatScenarioRole[BlackHatScenarioRole["LOW"] = 1] = "LOW";
    /**
   * @generated from enum value: BLACK_HAT_SCENARIO_ROLE_LIKELY = 2;
   */ BlackHatScenarioRole[BlackHatScenarioRole["LIKELY"] = 2] = "LIKELY";
    /**
   * @generated from enum value: BLACK_HAT_SCENARIO_ROLE_HIGH = 3;
   */ BlackHatScenarioRole[BlackHatScenarioRole["HIGH"] = 3] = "HIGH";
    return BlackHatScenarioRole;
}({});
// Retrieve enum metadata with: proto3.getEnumType(BlackHatScenarioRole)
proto3.util.setEnumType(BlackHatScenarioRole, "mono.datagateway.v1.BlackHatScenarioRole", [
    {
        no: 0,
        name: "BLACK_HAT_SCENARIO_ROLE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "BLACK_HAT_SCENARIO_ROLE_LOW"
    },
    {
        no: 2,
        name: "BLACK_HAT_SCENARIO_ROLE_LIKELY"
    },
    {
        no: 3,
        name: "BLACK_HAT_SCENARIO_ROLE_HIGH"
    }
]);
/**
 * Evidence provenance frozen at this revision's save; live intelligence remains live-owned.
 *
 * @generated from message mono.datagateway.v1.BlackHatEvidenceReference
 */ export class BlackHatEvidenceReference extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatEvidenceReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatEvidenceReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatEvidenceReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatEvidenceReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evidence_id = 1;
   */ _define_property(this, "evidenceId", ""), /**
   * @generated from field: string basis = 2;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string source_ref = 3;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_date = 4;
   */ _define_property(this, "sourceDate", ""), /**
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", ""), /**
   * Complete source row snapshot, including claim and supersedes lineage.
   *
   * @generated from field: string provenance_json = 6;
   */ _define_property(this, "provenanceJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatEvidenceReference, "runtime", proto3);
_define_property(BlackHatEvidenceReference, "typeName", "mono.datagateway.v1.BlackHatEvidenceReference");
_define_property(BlackHatEvidenceReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatAssessmentContent
 */ export class BlackHatAssessmentContent extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatAssessmentContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatAssessmentContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatAssessmentContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatAssessmentContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string expected_strategy = 1;
   */ _define_property(this, "expectedStrategy", ""), /**
   * @generated from field: string strengths = 2;
   */ _define_property(this, "strengths", ""), /**
   * @generated from field: string weaknesses = 3;
   */ _define_property(this, "weaknesses", ""), /**
   * @generated from field: string likely_approach = 4;
   */ _define_property(this, "likelyApproach", ""), /**
   * @generated from field: string our_response = 5;
   */ _define_property(this, "ourResponse", ""), /**
   * @generated from field: string unknowns = 6;
   */ _define_property(this, "unknowns", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatAssessmentContent, "runtime", proto3);
_define_property(BlackHatAssessmentContent, "typeName", "mono.datagateway.v1.BlackHatAssessmentContent");
_define_property(BlackHatAssessmentContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "expected_strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "strengths",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "weaknesses",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "likely_approach",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "our_response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "unknowns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatAssessmentVersion
 */ export class BlackHatAssessmentVersion extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatAssessmentVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatAssessmentVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatAssessmentVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatAssessmentVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string pursuit_id = 2;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * Stable assessment identity: one assessment per competitor participant.
   *
   * @generated from field: string participant_id = 4;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string company_profile_id = 5;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: int32 version = 6;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string supersedes_id = 7;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: mono.datagateway.v1.BlackHatAssessmentContent content = 8;
   */ _define_property(this, "content", void 0), /**
   * Qualitative assessment stays "unknown"; scenario pricing is separate.
   *
   * @generated from field: string pricing_state = 9;
   */ _define_property(this, "pricingState", ""), /**
   * Absent in OUT-03; reserved nullable numeric hook.
   *
   * @generated from field: optional double estimated_price = 10;
   */ _define_property(this, "estimatedPrice", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatEvidenceReference evidence_refs = 11;
   */ _define_property(this, "evidenceRefs", []), /**
   * @generated from field: string created_by = 12;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 13;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatScenario scenarios = 14;
   */ _define_property(this, "scenarios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatAssessmentVersion, "runtime", proto3);
_define_property(BlackHatAssessmentVersion, "typeName", "mono.datagateway.v1.BlackHatAssessmentVersion");
_define_property(BlackHatAssessmentVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content",
            kind: "message",
            T: BlackHatAssessmentContent
        },
        {
            no: 9,
            name: "pricing_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "estimated_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "evidence_refs",
            kind: "message",
            T: BlackHatEvidenceReference,
            repeated: true
        },
        {
            no: 12,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "scenarios",
            kind: "message",
            T: BlackHatScenario,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBlackHatAssessmentsRequest
 */ export class ListBlackHatAssessmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBlackHatAssessmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBlackHatAssessmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBlackHatAssessmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBlackHatAssessmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBlackHatAssessmentsRequest, "runtime", proto3);
_define_property(ListBlackHatAssessmentsRequest, "typeName", "mono.datagateway.v1.ListBlackHatAssessmentsRequest");
_define_property(ListBlackHatAssessmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBlackHatAssessmentsResponse
 */ export class ListBlackHatAssessmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBlackHatAssessmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBlackHatAssessmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBlackHatAssessmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBlackHatAssessmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatAssessmentVersion assessments = 1;
   */ _define_property(this, "assessments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBlackHatAssessmentsResponse, "runtime", proto3);
_define_property(ListBlackHatAssessmentsResponse, "typeName", "mono.datagateway.v1.ListBlackHatAssessmentsResponse");
_define_property(ListBlackHatAssessmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessments",
            kind: "message",
            T: BlackHatAssessmentVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveBlackHatAssessmentVersionRequest
 */ export class SaveBlackHatAssessmentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveBlackHatAssessmentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string participant_id = 4;
   */ _define_property(this, "participantId", ""), /**
   * 0 creates; stale writes/repeated clicks abort without a new revision.
   *
   * @generated from field: int32 expected_version = 5;
   */ _define_property(this, "expectedVersion", 0), /**
   * @generated from field: mono.datagateway.v1.BlackHatAssessmentContent content = 6;
   */ _define_property(this, "content", void 0), /**
   * Validated against the same tenant/Pursuit/participant.
   *
   * @generated from field: repeated string evidence_ids = 7;
   */ _define_property(this, "evidenceIds", []), /**
   * Full replacement in the new revision; empty remains qualitative.
   *
   * @generated from field: repeated mono.datagateway.v1.BlackHatScenarioInput scenarios = 8;
   */ _define_property(this, "scenarios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveBlackHatAssessmentVersionRequest, "runtime", proto3);
_define_property(SaveBlackHatAssessmentVersionRequest, "typeName", "mono.datagateway.v1.SaveBlackHatAssessmentVersionRequest");
_define_property(SaveBlackHatAssessmentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "content",
            kind: "message",
            T: BlackHatAssessmentContent
        },
        {
            no: 7,
            name: "evidence_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "scenarios",
            kind: "message",
            T: BlackHatScenarioInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveBlackHatAssessmentVersionResponse
 */ export class SaveBlackHatAssessmentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveBlackHatAssessmentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BlackHatAssessmentVersion assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveBlackHatAssessmentVersionResponse, "runtime", proto3);
_define_property(SaveBlackHatAssessmentVersionResponse, "typeName", "mono.datagateway.v1.SaveBlackHatAssessmentVersionResponse");
_define_property(SaveBlackHatAssessmentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: BlackHatAssessmentVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetBlackHatAssessmentHistoryRequest
 */ export class GetBlackHatAssessmentHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlackHatAssessmentHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string participant_id = 4;
   */ _define_property(this, "participantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlackHatAssessmentHistoryRequest, "runtime", proto3);
_define_property(GetBlackHatAssessmentHistoryRequest, "typeName", "mono.datagateway.v1.GetBlackHatAssessmentHistoryRequest");
_define_property(GetBlackHatAssessmentHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetBlackHatAssessmentHistoryResponse
 */ export class GetBlackHatAssessmentHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlackHatAssessmentHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Ascending; last is current. Empty is NotFound.
   *
   * @generated from field: repeated mono.datagateway.v1.BlackHatAssessmentVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlackHatAssessmentHistoryResponse, "runtime", proto3);
_define_property(GetBlackHatAssessmentHistoryResponse, "typeName", "mono.datagateway.v1.GetBlackHatAssessmentHistoryResponse");
_define_property(GetBlackHatAssessmentHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: BlackHatAssessmentVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatRateInput
 */ export class BlackHatRateInput extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatRateInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatRateInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatRateInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatRateInput, a, b);
    }
    constructor(data){
        super(), /**
   * observation | manual. Observation pins the correction-chain version using
   * RATE-07 lineage semantics; amount/unit/currency come from that exact row.
   *
   * @generated from field: string source = 1;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 3;
   */ _define_property(this, "observationVersion", 0), /**
   * Manual only. USD per unit, with a required explanation/source reference.
   *
   * @generated from field: string amount = 4;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: mono.datagateway.v1.BlackHatQuantityUnit unit = 5;
   */ _define_property(this, "unit", 0), /**
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatRateInput, "runtime", proto3);
_define_property(BlackHatRateInput, "typeName", "mono.datagateway.v1.BlackHatRateInput");
_define_property(BlackHatRateInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unit",
            kind: "enum",
            T: proto3.getEnumType(BlackHatQuantityUnit)
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioLineInput
 */ export class BlackHatScenarioLineInput extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioLineInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioLineInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioLineInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioLineInput, a, b);
    }
    constructor(data){
        super(), /**
   * Stable within a scenario, unique and nonempty.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string quantity = 3;
   */ _define_property(this, "quantity", ""), /**
   * @generated from field: mono.datagateway.v1.BlackHatQuantityUnit unit = 4;
   */ _define_property(this, "unit", 0), /**
   * Absent means unpriced, never zero.
   *
   * @generated from field: mono.datagateway.v1.BlackHatRateInput rate = 5;
   */ _define_property(this, "rate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioLineInput, "runtime", proto3);
_define_property(BlackHatScenarioLineInput, "typeName", "mono.datagateway.v1.BlackHatScenarioLineInput");
_define_property(BlackHatScenarioLineInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unit",
            kind: "enum",
            T: proto3.getEnumType(BlackHatQuantityUnit)
        },
        {
            no: 5,
            name: "rate",
            kind: "message",
            T: BlackHatRateInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioOverrideInput
 */ export class BlackHatScenarioOverrideInput extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioOverrideInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioOverrideInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioOverrideInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioOverrideInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 value_cents = 1;
   */ _define_property(this, "valueCents", protoInt64.zero), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioOverrideInput, "runtime", proto3);
_define_property(BlackHatScenarioOverrideInput, "typeName", "mono.datagateway.v1.BlackHatScenarioOverrideInput");
_define_property(BlackHatScenarioOverrideInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioInput
 */ export class BlackHatScenarioInput extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioInput, a, b);
    }
    constructor(data){
        super(), /**
   * Stable within an assessment, unique and nonempty.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatScenarioLineInput lines = 3;
   */ _define_property(this, "lines", []), /**
   * @generated from field: mono.datagateway.v1.BlackHatScenarioOverrideInput override = 4;
   */ _define_property(this, "override", void 0), /**
   * GRW-07: which end of the range this scenario prices (at most one scenario
   * per non-unspecified role) and the period it covers (0-600 months).
   *
   * @generated from field: mono.datagateway.v1.BlackHatScenarioRole role = 5;
   */ _define_property(this, "role", 0), /**
   * @generated from field: int32 period_months = 6;
   */ _define_property(this, "periodMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioInput, "runtime", proto3);
_define_property(BlackHatScenarioInput, "typeName", "mono.datagateway.v1.BlackHatScenarioInput");
_define_property(BlackHatScenarioInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lines",
            kind: "message",
            T: BlackHatScenarioLineInput,
            repeated: true
        },
        {
            no: 4,
            name: "override",
            kind: "message",
            T: BlackHatScenarioOverrideInput
        },
        {
            no: 5,
            name: "role",
            kind: "enum",
            T: proto3.getEnumType(BlackHatScenarioRole)
        },
        {
            no: 6,
            name: "period_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioRate
 */ export class BlackHatScenarioRate extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source = 1;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 3;
   */ _define_property(this, "observationVersion", 0), /**
   * @generated from field: string amount = 4;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: mono.datagateway.v1.BlackHatQuantityUnit unit = 5;
   */ _define_property(this, "unit", 0), /**
   * Manual explanation or authoritative observation JSON snapshot.
   *
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * Authenticated actor who chose the rate for this revision.
   *
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioRate, "runtime", proto3);
_define_property(BlackHatScenarioRate, "typeName", "mono.datagateway.v1.BlackHatScenarioRate");
_define_property(BlackHatScenarioRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unit",
            kind: "enum",
            T: proto3.getEnumType(BlackHatQuantityUnit)
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioLine
 */ export class BlackHatScenarioLine extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string quantity = 3;
   */ _define_property(this, "quantity", ""), /**
   * @generated from field: mono.datagateway.v1.BlackHatQuantityUnit unit = 4;
   */ _define_property(this, "unit", 0), /**
   * @generated from field: mono.datagateway.v1.BlackHatScenarioRate rate = 5;
   */ _define_property(this, "rate", void 0), /**
   * Quantity x exact rate, rounded half up per line.
   *
   * @generated from field: optional int64 amount_cents = 6;
   */ _define_property(this, "amountCents", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioLine, "runtime", proto3);
_define_property(BlackHatScenarioLine, "typeName", "mono.datagateway.v1.BlackHatScenarioLine");
_define_property(BlackHatScenarioLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unit",
            kind: "enum",
            T: proto3.getEnumType(BlackHatQuantityUnit)
        },
        {
            no: 5,
            name: "rate",
            kind: "message",
            T: BlackHatScenarioRate
        },
        {
            no: 6,
            name: "amount_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenarioOverride
 */ export class BlackHatScenarioOverride extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenarioOverride().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenarioOverride().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenarioOverride().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenarioOverride, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 value_cents = 1;
   */ _define_property(this, "valueCents", protoInt64.zero), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string actor_user_id = 3;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenarioOverride, "runtime", proto3);
_define_property(BlackHatScenarioOverride, "typeName", "mono.datagateway.v1.BlackHatScenarioOverride");
_define_property(BlackHatScenarioOverride, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BlackHatScenario
 */ export class BlackHatScenario extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatScenario().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatScenario().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatScenario().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatScenario, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * USD for this milestone.
   *
   * @generated from field: string currency = 3;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatScenarioLine lines = 4;
   */ _define_property(this, "lines", []), /**
   * COMPLETE | PARTIAL; overrides never hide missing rates.
   *
   * @generated from field: string pricing_state = 5;
   */ _define_property(this, "pricingState", ""), /**
   * Sum of rounded priced lines, retained under override.
   *
   * @generated from field: int64 known_subtotal_cents = 6;
   */ _define_property(this, "knownSubtotalCents", protoInt64.zero), /**
   * @generated from field: repeated string unpriced_line_ids = 7;
   */ _define_property(this, "unpricedLineIds", []), /**
   * @generated from field: mono.datagateway.v1.BlackHatScenarioOverride override = 8;
   */ _define_property(this, "override", void 0), /**
   * Absent for PARTIAL without an explicit override.
   *
   * @generated from field: optional int64 effective_total_cents = 9;
   */ _define_property(this, "effectiveTotalCents", void 0), /**
   * quantity-rate-usd-half-up-v1
   *
   * @generated from field: string calculation_version = 10;
   */ _define_property(this, "calculationVersion", ""), /**
   * GRW-07
   *
   * @generated from field: mono.datagateway.v1.BlackHatScenarioRole role = 11;
   */ _define_property(this, "role", 0), /**
   * GRW-07: 0 = not set
   *
   * @generated from field: int32 period_months = 12;
   */ _define_property(this, "periodMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatScenario, "runtime", proto3);
_define_property(BlackHatScenario, "typeName", "mono.datagateway.v1.BlackHatScenario");
_define_property(BlackHatScenario, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lines",
            kind: "message",
            T: BlackHatScenarioLine,
            repeated: true
        },
        {
            no: 5,
            name: "pricing_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "known_subtotal_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "unpriced_line_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "override",
            kind: "message",
            T: BlackHatScenarioOverride
        },
        {
            no: 9,
            name: "effective_total_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 10,
            name: "calculation_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "role",
            kind: "enum",
            T: proto3.getEnumType(BlackHatScenarioRole)
        },
        {
            no: 12,
            name: "period_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
